module.exports = __webpack_public_path__ + "static/media/appstore.43a0180c.png";